import styled from "styled-components";
import { keyframes, css } from "@emotion/react";
import "../../../bgGlobal.css";


const slideIn = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-100%);
    opacity: 0;
  }
`;

export const HeaderSidHome = styled.div`
  background: var(--bg--header-side);
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px;
  width: ${(props) => (props.reduced ? "65px" : "320px")};
  height: auto;
  border-radius: 12px;
  transition: width 0.3s ease;
  .content {
    display: ${(props) => (props.reduced ? "none" : "block")};
  }
`;

export const AnimatedHeaderSidHome = styled(HeaderSidHome)`
  .display-flex-padding-5{
    display:flex;
    padding:5px;
  }

  .text-align-left{
    text-align: left;
  }

  .padding-5{
    padding: 5px;
  }

  .padding-8{
    padding:8px;
  }

  .header-flex{
    display:flex;
  }

  .margin-right-5{
    margin-right: 5px;
  }

  .width-long{
    width:100%;
  }

  .width-215{
    width: 215px;
  }

  .text-align-left{
    text-align: left;
  }

  .cursor-not-allowed {
    cursor: not-allowed;
    pointer-events: none;
  }

  .cursor-pointer {
    cursor: pointer;
    pointer-events: auto;
  }

  .hamburger{
  width: 90%;
  padding: 10px;
  }

  .btn-hamburger{
   width: 40px;
  height: 40px;
  border-radius: 40px;
  box-shadow: var(--box-shadow-btn);
  background: var(--bg-white);
  cursor: pointer;
}

  .font-icon{
    font-size: 28px;
    position: relative;
    top: 7px;
    color: var(--bg-color-930);
  }



 
  .top-20{
  top: 20px;
  }

  ul{
    padding: 0;
  }

  ul li {
    list-style-type: none;
    color: #5b5959;
    font-size: 12px;
  }

  ul li input {
    border: none;
  }
  

  ${({ isVisible }) =>
    isVisible
      ? css`
          animation: ${slideIn} 0.5s forwards;
        `
      : css`
          animation: ${slideOut} 0.5s forwards;
        `}
`;













export const ComponentTitle = styled.div`
     text-align: left;
    padding: 12px;
    color: #005a9e;
    font-size: 24px;
    margin-right: 0px;
    width: 490px;

span{
  position:relative;
  left:15px;
}
`;

export const NewClient = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  margin: 10px;
  border-radius: 50px;
  box-shadow: rgb(0 0 0 / 4%) 0px 2px 4px;
  background: ${({ action }) => (action ? '#198754' : '#bfbfbf')};
  position: relative;
  top: -7px;
  color: #fff;
  font-weight: 700;
  font-size: 28px;
  cursor: pointer;

  &:hover + div {
    display: block;
  }
`;

export const ModalHouver = styled.div`
  padding: 5px;
  width: 80px;
  text-align: center;
  border-radius: 4px;
  box-shadow: rgb(50 50 93 / 4%) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  font-size: 14px;
  color: #6e6e6e;
  position: absolute;
  top: -18px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  display: none;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: white transparent transparent transparent;
  }
`;

export const TableWithScrollY = styled.div`
    height: 350px;

  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  @media only screen and (max-width: 500px) {
    left: 40%;
    width: 200px;
    height: 500px;
    padding: 15px;
    font-size: 12px !important;
  }
`

export const Table = styled.div`
`;

export const Column = styled.div`
  width: 100%;
  display: flex;
  margin-bottom:5px;
`;

export const ItemTable = styled.div`
  width: 100%;
  height: 80px;
  border-radius: 8px;
  border-left: 3px solid #e3e3e3;
  background: #fff;
  box-shadow: rgb(0 0 0 / 2%) 0px 3px 3px 0px;

  ul {
    display: flex;
    padding: 5px;
    margin-left: 40px;

    li {
      margin: 10px;
      list-style-type: none;
      font-size: 14px;
      color: #737373;
    }
  }
`;

export const Titulos = styled.div`
width: 100%;

ul {
  display: flex;
  padding: 0;
  margin-left: 43px;
  position: relative;
  top: 20px;
  font-weight: 600;

  li {
    margin: 10px;
    list-style-type: none;
    font-size: 14px;
    color: #737373;
  }
  .rp{
    width: 385px;
    text-align: right;
  }
}

`

export const TitlleTarefas = styled.div`
  ul {
    display: flex;
    padding: 5px;
    margin-left: 30px;

    li {
      margin: 10px;
      list-style-type: none;
      font-size: 16px;
      font-weight: 700;
      color: #737373;
    }
  }

  .width {
    width: 325px;
    text-align: left;
  }

  .width35 {
    position: relative;
    left: 35px;
  }
`;

export const ContainerSearch = styled.div`
  width: 100%;

  .bt-excel{
      width: 40px;
    height: 40px;
    border-radius: 40px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    background: #fff;
    cursor: pointer;
    display: flex
;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: #005a9e;
    color: #fff;
    font-size: 23px;
  }

  .container-title {
    width: 50%;
    text-align: left;
    justify-content: flex-start;
    display: flex;
    align-items: center;
    color: #005a9e;
    font-size: 22px;
    font-weight: 700;
  }

  .display-flex {
    display: flex;
  }

  .justify-content-right{
    justify-content: right;
  }


  .margin-button{
    margin-bottom: 10px;
    margin-top: 5px;
  }

  .margin-5{
  margin: 5px;
  }

  .style-info-label{
      color: #818181;
    font-size: 14px;
  }

  .padding-5 {
    padding: 5px;
  }

  .text-align-right {
    text-align: right;
  }

  .containerCreateTasks {
    margin: 0 auto;
  }

  .containerCreateSearch {
    width: 100%;
  }

  .newClient {
    display: flex;
  }

  .inputSerach {
    width: 50%;
    padding: 0 20px;
    position: relative;
    top: 4px;
  }
  .text-align-left {
    text-align: left;
  }
  .padding-5 {
    padding: 5px;
  }

  .style-info {
    background: #ffffff;
    padding: 10px;
    border-radius: 8px;
    width: 337px;
    margin-bottom: 10px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
      rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  }

  .title-ordem-serv {
    color: #0361a7;
  }
`;

export const ContainerCreate = styled.div`
  width: 65%;
  padding: 14px;
  border-radius: 50px;
  border: none;
  margin:0 auto;
  height: 250px;
`;

export const InputSearchClient = styled.input`
  width: 100%;
  padding: 14px;
  border-radius: 50px;
  border: none;
  box-shadow: rgb(0 0 0 / 4%) 0px 2px 4px;
`;

export const InputIdClient = styled.input`
width: 100px;
padding: 14px;
border-radius: 50px;
border: none;
margin: 10px;
box-shadow: rgb(0 0 0 / 4%) 0px 2px 4px;

&:focus {
  border: none;
  outline: none;
}
`

export const InputSelect = styled.input`
  padding: 14px;
  border: none;
  width: 400px;
  border-radius: 8px;
  color: #747070f2;
  margin: 10px;
  box-shadow: rgb(0 0 0 / 4%) 0px 2px 4px;

  &:focus {
  border: none;
  outline: none;
}
`;

export const ListOption = styled.div`
  position: relative;
  top: 12px;
  height: auto;
  max-height: 200px; /* Define a altura máxima para ativar o scroll */
  overflow-y: auto; /* Ativa o scroll vertical se necessário */
  border-radius: 12px;
  background: #efefefa6;
  padding: 10px;
  font-size: 12px;
  color: #847f7ff2;
  box-shadow: rgb(0 0 0 / 21%) 0px 25px 20px -20px;
  text-align: left;

  .optioninvaalue{
    text-align: center;
    box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
  }
`;







export const Centralizando = styled.div`
  margin: 0 auto; 
    max-width: 100%;
`;













export const BtnNext = styled.div`
  background-color: #005a9e;
  border-radius: 12px;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 20px;
  list-style: none;
  margin: 10px;
  outline: none;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  transition: color 100ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;

   &:hover {
    background-color: #198754d6;
    transition: 0.3s;
  }
`;

export const BtnBlue = styled.div`
  background-color: #005a9e;
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  align-items: center;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 20px;
  list-style: none;
  margin: 0;
  outline: none;
  padding: 10px 20px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: color 100ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
   display: flex;
    align-items: center;

  &:hover {
    color: #fff;
    border-color: #2e59d9;
    background: #2e59d9!important;
    transition: 0.2s;
  }
`;

export const BtnClean = styled.div`
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: black;
  border: 1px solid #c1c1c1;
  cursor: pointer;
  display: inline-block;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 20px;
  list-style: none;
  margin: 3px;
  outline: none;
  padding: 10px 20px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: color 100ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  background: #fff;
  width: 98%;

  &:hover {
    color: #4096ff;
    border: 1px solid #4096ff;
    background: #ffffff;
    transition: 0.2s;
  }
`;

export const BtnCinza = styled.div`
 border-radius: 12px;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 20px;
  list-style: none;
     margin: 0px;
    outline: none;
    padding: 10px 27px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: color 100ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  background: #b3b3b6;
      width: 98%;
`

export const BtnSearch = styled.div`
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 20px;
  list-style: none;
  margin: 3px;
  outline: none;
  padding: 10px 20px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: color 100ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  background: #005A9E;
  width: 98%;

  &:hover{
    color: #fff!important;
    border-color: #2e59d9!important;
    background: #2e59d9!important;
    transition: 0.2s;
    }
`;


export const SkeletonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingCircle = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid #e0e0e0;
  border-top: 2px solid #999;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const SkeletonBox = styled.div`
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite ease-in-out;
  
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.6; }
    100% { opacity: 1; }
  }
`;

export const BtnSkeleton = styled(SkeletonBox)`
  width: 180px;
  height: 30px;
`;
